/*
* Engine Actions
*/

import { ABSTRACT_EVENT_TYPES } from '../consts/abstractEventTypes'
import { OCCURING_EVENT_TYPES } from '../consts/occuringEventTypes'
import { ARG_TYPES } from '../consts/argTypes'

export function statusUpdateComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.STATUS_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.STATUS_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Game Status Update',
    description: 'The game status becomes equals to {arg0:status}',
    argTypes:[ARG_TYPES.STATUS],
  }
}

export function languageUpdateComparison(language) {
  return {
    type: ABSTRACT_EVENT_TYPES.LANGUAGE_UPDATE_COMPARISON,
    listenType:OCCURING_EVENT_TYPES.LANGUAGE_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Language Update',
    description: 'The language becomes {arg0:language}',
    argTypes:[ARG_TYPES.LANGUAGE],
  }
}

export function countDownUpdateComparison(newTime) {
  return {
    type: ABSTRACT_EVENT_TYPES.COUNT_DOWN_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.COUNT_DOWN_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Time Of The Game (Min and Sec)',
    description: 'The count down becomes equals to {arg0:integer} minutes and {arg1:integer} seconds.',
    argTypes:[ARG_TYPES.INTEGER, ARG_TYPES.INTEGER],
    newTime,
  }
}

export function countDownUpdateTotalSecComparison(newTime) {
  return {
    type: ABSTRACT_EVENT_TYPES.COUNT_DOWN_UPDATE_TOTAL_SEC_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.COUNT_DOWN_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Time Of The Game (Total Sec)',
    description: 'The count down becomes equals to {arg0:integer} seconds.',
    argTypes:[ARG_TYPES.INTEGER],
    newTime,
  }
}

export function elapsedSecondsUpdateComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.ELAPSED_SECONDS_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.ELAPSED_SECONDS_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Elapsed Seconds Of The Game',
    description: 'The elapsed seconds becomes equals to {arg0:integer} seconds.',
    argTypes:[ARG_TYPES.INTEGER],
  }
}

export function everySecondUpdate() {
  return {
    type: ABSTRACT_EVENT_TYPES.EVERY_SECOND_UPDATE,
    listenType: OCCURING_EVENT_TYPES.ELAPSED_SECONDS_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Every Second',
    description: 'Every second.',
    argTypes:[],
  }
}

export function timerExpiredUpdate() {
  return {
    type: ABSTRACT_EVENT_TYPES.TIMER_EXPIRED_UPDATE,
    listenType: OCCURING_EVENT_TYPES.TIMER_EXPIRED,
    returnType: ARG_TYPES.EVENT,
    name: 'Time - Timer expired',
    description: '{arg0:timer} expires.',
    argTypes:[ARG_TYPES.TIMER],
  }
}

export function variableUpdateComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.VARIABLE_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.VARIABLE_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Value of Variable Equals To',
    description: '{arg0:Variable} becomes equals to {arg1:value}.',
    argTypes:[ARG_TYPES.VARIABLE, ARG_TYPES.ARG_0_TYPE],
  }
}

export function variableUpdateAny() {
  return {
    type: ABSTRACT_EVENT_TYPES.VARIABLE_UPDATE_ANY,
    listenType: OCCURING_EVENT_TYPES.VARIABLE_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Value of Variable',
    description: '{arg0:Variable} changes.',
    argTypes:[ARG_TYPES.VARIABLE],
  }
}

export function padInputButtonDownComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.PAD_INPUT_BUTTON_DOWN_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.PAD_INPUT_BUTTON_DOWN,
    returnType: ARG_TYPES.EVENT,
    name: 'Pad Button Pressed',
    description: 'The Game Master pressed the button {arg0:id}.',
    argTypes:[ARG_TYPES.PAD_INPUT_BUTTON],
  }
}

export function padInputCheckboxCheckedComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.PAD_INPUT_CHECKBOX_CHECKED_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.PAD_INPUT_CHECKBOX_CHECKED,
    returnType: ARG_TYPES.EVENT,
    name: 'Pad Checkbox Checked',
    description: 'The Game Master checked {arg0:id}.',
    argTypes:[ARG_TYPES.PAD_INPUT_CHECKBOX],
  }
}

export function padInputCheckboxUncheckedComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.PAD_INPUT_CHECKBOX_UNCHECKED_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.PAD_INPUT_CHECKBOX_UNCHECKED,
    returnType: ARG_TYPES.EVENT,
    name: 'Pad Checkbox Unchecked',
    description: 'The Game Master checked {arg0:id}.',
    argTypes:[ARG_TYPES.PAD_INPUT_CHECKBOX],
  }
}

export function hintPublished() {
  return {
    type: ABSTRACT_EVENT_TYPES.PAD_HINT_PUBLISHED,
    listenType: OCCURING_EVENT_TYPES.PAD_PUBLISH_HINT,
    returnType: ARG_TYPES.EVENT,
    name: 'Hint Published',
    description: 'The Game Master sent a hint.',
    argTypes:[],
  }
}

export function gpioReadUpdateComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.GPIO_READ_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.GPIO_READ_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Pin value changed',
    description: 'The pin {arg0:pinId} switched to {arg1:value}.',
    argTypes:[ARG_TYPES.FIXTURE_INPUT, ARG_TYPES.BOOLEAN],
    defaultArgs:[
      {mode:'VALUE', value:'0'},
      {mode:'PREDEF', value:'BOOLEAN_TRUE'},
      ],
  }
}

export function gpioReadUpdateAny() {
  return {
    type: ABSTRACT_EVENT_TYPES.GPIO_READ_UPDATE_ANY,
    listenType: OCCURING_EVENT_TYPES.GPIO_READ_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Input value changed',
    description: 'The input {arg0:pinId} changed.',
    argTypes:[ARG_TYPES.FIXTURE_INPUT],
    defaultArgs:[
      {mode:'VALUE', value:'0'},
      ],
  }
}

export function podNetworkUpdateComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.POD_NETWORK_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.POD_NETWORK_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Network update',
    description: 'The message received {arg0:this value}',
    argTypes:[ARG_TYPES.STRING],
    defaultArgs:[
      {mode:'VALUE', value:'0'},
      ],
  }
}

export function podNetworkKVComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.POD_NETWORK_KV_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.POD_NETWORK_KV,
    returnType: ARG_TYPES.EVENT,
    name: 'Network Key Value update',
    description: 'The message received {arg0:key}:{arg1:value}',
    argTypes:[ARG_TYPES.STRING, ARG_TYPES.INTEGER],
    defaultArgs:[
      {mode:'VALUE', value:'0'},
      {mode:'VALUE', value:'1'},
      ],
  }
}

export function bundleToEngineUpdateComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.BUNDLE_TO_ENGINE_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.BUNDLE_TO_ENGINE_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Bundle update',
    description: 'The message received is {arg0:this value}',
    argTypes:[ARG_TYPES.BO_KEY],
    defaultArgs:[
      {mode:'VALUE', value:'hello'},
      ],
  }
}

export function bundleToEngineKVUpdateComparison() {
  return {
    type: ABSTRACT_EVENT_TYPES.BUNDLE_TO_ENGINE_KEY_VALUE_UPDATE_COMPARISON,
    listenType: OCCURING_EVENT_TYPES.BUNDLE_TO_ENGINE_KEY_VALUE_UPDATE,
    returnType: ARG_TYPES.EVENT,
    name: 'Bundle update key - value',
    description: 'The message received is {arg0:key} with value {arg1:value}',
    argTypes:[ARG_TYPES.BOKV_KEY, ARG_TYPES.STRING],
    defaultArgs:[
      {mode:'VALUE', value:'hello'},
      {mode:'VALUE', value:'SUCCESS'}
      ],
  }
}

export function sfxEndedUpdate() {
  return {
    type: ABSTRACT_EVENT_TYPES.SFX_ENDED_UPDATE,
    listenType: OCCURING_EVENT_TYPES.SFX_ENDED,
    returnType: ARG_TYPES.EVENT,
    name: 'Sfx Ended',
    description: 'The sfx {arg0:sfx} ended',
    argTypes:[ARG_TYPES.SFX],
  }
}